// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./BebasNeue.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'BebasNeue';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: normal;
    font-style: normal;
}

/*@font-face {
    font-family: 'Montserrat';
    src: url('./Montserrat-VariableFont_wght.woff');
    font-weight: normal;
    font-style: normal;
}*/



.App{
    text-align: center;
    background-color: #f8f8f8;

}


.LoginModalOverlay{
  background-color: #9bb9d5;
  top: 0;
  left: 0;
  width: 100%;        /* Full width */
  height: 100%;       /* Full height */
  z-index: 1000;
  position: fixed;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.LoginModal{
  top: 0;
  left: 0;
  width: 100%;        /* Full width */
  height: 100%;       /* Full height */
  z-index: 1000;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;

}

.loginFormDiv{
  background-color: #f8f8f8;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  

}

h1{
    font-family: 'BebasNeue', sans-serif;

}

h2{
    font-family: 'BebasNeue', sans-serif;
}




.MenuButtons{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 5%;
    justify-content: space-between;
    position: fixed;
    background-color: #27292b;
    z-index: 1;
    
}

.MenuButtonsSection{
    display: flex;
    flex-direction: row;   
    padding-bottom: 1vh;
}



.button-content{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.8vh
}

.UserButton{
   
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: x-large;
    margin-left:1vh;
    width: auto;
    background-color: transparent;
    font-family: 'BebasNeue', sans-serif;
    font-weight: bold;
    margin-bottom: 1vh;
    border-radius: 0%;
    
    
   

}

/*.UserButton:hover{
  
    background-color: #9bb9d5;

}*/

.username:hover{
    background: white; 
    -webkit-background-clip: text; 
    -webkit-text-fill-color: transparent; 
    transform: scale(1.05);
    
}
.username{
    background: linear-gradient(to right, #23a1ee 5%, #9ddeec 95%); 
    -webkit-background-clip: text; 
    -webkit-text-fill-color: transparent; 
    transform: translateZ(0) scale(1);
    transition: transform .2s;
  

}

.guest{
  background: linear-gradient(to right, #23a1ee 5%, #9ddeec 95%); 
  -webkit-background-clip: text; 
  -webkit-text-fill-color: transparent; 
  transform: translateZ(0) scale(1);
  transition: transform .2s;
  font-family: 'BebasNeue', sans-serif;
  font-size: x-large;
  font-weight: bold;
  margin-left: 2vh;


}

.guestDiv{
  display: flex;
  align-items: center;

}


.BlueButton{
  display: flex;
  flex-direction: row;
  align-items: center;
  width: auto;
  background-color: transparent;
  font-family: 'BebasNeue', sans-serif;
  font-weight: bold;
  font-size: xx-large;
  

}

.LogoutButton p{
  font-family: 'BebasNeue', sans-serif;
  font-size: x-large;
  transform: translateZ(0) scale(1);
  transition: transform .2s;
}

.LogoutButton:hover p{
  color: #9bb9d5;
  transform: scale(1.05);
}

.Share-logo:hover{
    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);
    transform: scale(1.05);
}

.Logout-logo:hover{
    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);
    transform: scale(1.05);
}



.LogoutButton{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;
    margin-right: 1vh;
    background-color: transparent;
   

}


.Share-logo{
    height: 3.7vh;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
  
}

.Logout-logo{
    height: 3.7vh;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
}

.LogoContainer{
    display: flex;
    flex-direction: row;
    justify-content: center;  
}

.App-logo{
    height: 25vh;
    border-radius: 50%;
    box-shadow: 0 0.5vh 1vh rgba(0, 0, 0, 0.1);
    margin-top: 7vh;

}

.tabbed{
    display: flex;
    margin-top: 2vh;
    flex-direction: row;
    justify-content: center;
}
.InputQuestion{
    display: flex;
    flex-direction: column;
}

.QuestionClassForm{
    display: flex;
    flex-direction: row;
    gap: 1vh;
    width: 60%;
    
}


.QuestionClass{
    font-size: x-large;
    border-top-left-radius: 3vh;
	border-bottom-left-radius: 3vh;
    border-top-right-radius: 3vh;
	border-bottom-right-radius: 3vh;
    text-align: left;
    outline: 0.3vh solid #27292b;
    transition: outline 0.1s ease-out;
    font-family: 'Montserrat', sans-serif;
    
  
    
  }

  .QuestionClass:hover{
    outline: 0.3vh solid #9bb9d5;
    border: 0.3vh solid transparent;
    transition: outline 0.1s ease-in;
   
  }

  .QuestionClass:focus{
    outline:  0.3vh solid #6fa4bf;
    border: 0.3vh solid transparent;
  }


  

.QuestionSection{
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 1vh;
}

.AnswerContainer{
    display: flex;
    flex-direction: column;
    width: 60%;
    
    
}

.Answer{
    display: flex;
    flex-direction: row;
    justify-content: center;

}

  
.document-section {
    display: flex;
    flex-wrap: wrap;
    gap: 2vh;
    margin-left: 1%;
    margin-top: 4vh;
    width: 120%;
  }
  
  .document-square {
    width: 17.5vh;  /* Reduced width */
    height: 17.5vh;  /* Reduced height */
    border: 0.3vh solid #ccc;
    padding: 0.5vh;  /* Reduced padding */
    overflow: hidden;
    background-color: #f9f9f9;
    box-shadow: 1vh 0.8vh 1vh rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .document-title {
    font-size: large;  /* Reduced font size */
  
    text-align: left;
    font-family: 'Montserrat', sans-serif;
    margin-top: 0vh;
    font-weight: 500;
    
  }
  
  .no-underline-link {
    text-decoration: none; /* Remove underline */
    color: inherit; /* Inherit the color from the parent */
  }
  
  .no-underline-link:hover {
    text-decoration: none; /* Remove underline on hover */
    color: inherit; /* Inherit the color from the parent */
  }
  
  
  .document-square.center {
    justify-content: center;  /* Center content vertically */
    align-items: center;      /* Center content horizontally */
    text-align: center;       /* Center text */
  }
  
  .document-section:hover {
    cursor: pointer; /* Change cursor to hand on hover */
  }
  
  .sources-section h2{
   text-align: left;
   margin-left: 1vh;
    
  }

.StatusMessage{
    text-align: left;
    margin-left: 1vh;


}

.output-section{
    text-align: justify;
    background-color: #f1f1f1;
    padding: 3.5vh;
    margin-bottom: 2vh;
    
    
}
.output-verification {
    background-color: #fafafa;
    border-radius: 4px;
    padding: 10px;
    margin: 20px;
    max-width: 770px;
  
  }
  
  .output-tokens {
    white-space: pre-line; /* Ensures that line breaks are respected */
    color: #333;
    font-size: larger;
    line-height: 3.5vh;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
 
   
  }

  .spinner {
    display: inline-block;
    vertical-align: auto;
    margin-left: 1vh; 
    width: 1.25vh;
    height: 1.25vh;
    border: 0.5vh solid #9bb9d5;
    border-radius: 50%;
    border-top: 0.5vh solid #27292b;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .green-ball, .red-ball, .gray-ball,.orange-ball {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    vertical-align: middle;
    display: inline-block;
    margin-right: 5px;
  }
  
  .green-ball {
    background-color: #00ff00; /* Green color */
  }
  
  .red-ball {
    background-color: #ff0000; /* Red color */
  }
  
  .gray-ball{
    background-color: gray;
  }
  
  .orange-ball{
    background-color:orange;
  }
  
  .tooltip {
    position: relative;
    display: inline-block;
  }
  
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 35%;
    background-color: #f8f8f8;
    color: #000;
    text-align: justify;
    border-radius: 1vh;
    padding: 1.5vh;
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    box-shadow: 0vh 1vh 3vh rgba(0,0,0,0.1);
    opacity: 0;
    transition: opacity 0.3s;
    font-size: small;
    
  }
  
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }


  #settings-btn{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: transparent;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
    
    
    
  }

  #settings-btn:hover{
    transform: scale(1.05);

  }

  .AskButton{
    background-color: transparent;
   
  }

 
  .AskLogo:hover{  
    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);
    transform: scale(1.05);
  }

  .SettingsLogo:hover{  
    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);
    transform: scale(1.05);
  }

  .SettingsLogo{
    height: 4.5vh;
    position: relative;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
    
  }

  .AskLogo{
    height: 4.5vh;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
  }

#inputMessage{
    font-family: 'Montserrat', sans-serif;
    font-size: large;
}

body{
    background-color: #f8f8f8;
}

.OptionButton{
    background-color: #27292b;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: x-small;
    width: 98%;
    height: 3.5vh;
    border-top-left-radius: 3vh;
	border-bottom-left-radius: 3vh;
    border-top-right-radius: 3vh;
	border-bottom-right-radius: 3vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
}

.OptionButton:hover{
    background-color: #9bb9d5;
    transform: scale(1.05);
}


.Option-logo{
    height: 2vh;
}



.SharingModalContent{
    position: fixed;
   /* border: 1px solid #ccc;*/
   border: 0.25vh solid #9bb9d5;
    border-radius: 2vh;
    width: 15%;
   /* box-shadow: 0 0.5vh 1.5vh rgba(0, 0, 0, 0.1);*/
    margin-top: 3%;
    margin-left: 80%;
    background-color: white;
 
}



.copiedMessage{
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0;
    font-size: small;

}

.checkmark{
    height: 2.5vh;
}
.copiedMessage h1{
    font-family: 'BebasNeue', sans-serif;
    font-size: x-large;
    
}

.sharingContainer{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 4%;
    

}

.sharing-options{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 0.2vh;
    row-gap: 0;
    
   
}

#share-heading{
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: small;
    margin-left: 3%;
    margin-bottom: 0%;


}




.ModalContent{
    position: fixed;
    background-color: white;
    border: 0.25vh solid #9bb9d5;
    border-radius: 2vh;
    width: 17%;
    margin-left: 1%;
    margin-top: -15%;
    z-index: 1;
   

}

.ModalContent h2 {
  font-size: larger;
}

.ModalContent label, option{
    font-family: 'Montserrat', sans-serif;
   
}



.SearchConfiguration{
    display: flex;
    flex-direction: row;
    justify-content: center;
       
}

.SearchConfiguration label{
    font-size: small;
    font-weight: 400;
}

.search-section{
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
}



.WeightsConfiguration{
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-top: 5%;
    margin-left: 10%;
}
.weight-labels{
    display: flex;
    flex-direction: column;
    width: 80%;
    
}

.weight-labels label{
    font-size: small;
    text-align: left;
}



.weight-buttons{

    display: flex;
    flex-direction: row;
    width: 110%;
    justify-content: space-between;
    margin-top: -2.5vh;
    margin-left: -3%;
    
     

}

.slider{
  accent-color: #9bb9d5;
  cursor: pointer;
  
}

.weight-btn-container{
    display: flex;
 
    flex-direction: row;
    align-items: center;
}

.weightSliderContainer{
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: -0.5vh;
}
.weight-buttons button{
    font-size: smaller;
    text-align: center;
    background-color: transparent;
    color:#27292b;
    font-family: 'Montserrat', sans-serif;
    font-weight: bold;
}

.DocumentNumConfiguration{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.DocumentNumConfiguration label{
  font-size: small;
}

.combobox{
  width: 25%;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  background-color: #9bb9d5;
  border-top-left-radius: 3vh;
	border-bottom-left-radius: 3vh;
    border-top-right-radius: 3vh;
	border-bottom-right-radius: 3vh;
  font-size: x-small;
  
  
}

.combobox:hover{
  background-color: #27292b;
  color: white;
}

.combobox:focus{
  background-color: #27292b;
  color: white;
}

.date-picker-group{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 37%;
}

.date-picker-group label{
  font-family: 'Montserrat', sans-serif;
  font-size: small;
}

.date-picker-group input{
  height: 10%;
  margin-top: 1vh;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: x-small;
  background-color: #9bb9d5;
  border-top-left-radius: 3vh;
	border-bottom-left-radius: 3vh;
    border-top-right-radius: 3vh;
	border-bottom-right-radius: 3vh;
  width: 65%;
}

.date-picker-group:hover input{
  
  background-color: #27292b;
  color: white;
}

.date-picker-group:focus{
  
  background-color: #27292b;
  color: white;
}
.DateConfiguration{
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  gap: 10%;
  margin-top: 2vh;
}

.temperature-desc{
  width: 110%;
  font-size: smaller;
  display: flex;
  text-align: center;
}

#tempSlider{
  margin-top: 0%;

}

#StreamConfiguration{
  margin-bottom: 3%;
}

@media (max-width: 1520px){
  .ModalContent{
    width: 30%;
    
  }
}
@media (max-width: 1000px){

  .ModalContent{
    margin-top: 7vh;
    width: 50%;
  }

  .SharingModalContent{
    width: 40%;
    margin-top: 7vh;
    margin-left: 58%;
    z-index: 1;   

  }
  

}

@media (max-width: 1000px){
  .ModalContent{
    margin-top: -20vh;
    margin-left: 1vh;
    
  }
}

@media (max-height: 500px){
  .ModalContent{
    margin-top: -43vh;
    margin-left: 1vh;
    width: 35%;
  
    
  }

  .ModalContent h2{
    font-size: small;
  }

  .combobox{
    font-size: xx-small;
  }

  .search-section label{
    font-size: xx-small;
  }

  .weight-labels label{
    font-size: xx-small;
  }

  .DocumentNumConfiguration label{
    font-size: xx-small;
  }

  .SharingModalContent{
    width: 25%;
    margin-left: 120vh;
  }



}

@media (min-height: 501px) and (max-height: 1000px){
  .ModalContent{
    margin-top: -30vh;
    margin-left: 1vh;
    width: 40%;
  
    
  }

 /* .ModalContent h2{
    font-size: small;
  }

  .combobox{
    font-size: xx-small;
  }

  .search-section label{
    font-size: xx-small;
  }

  .weight-labels label{
    font-size: xx-small;
  }

  .DocumentNumConfiguration label{
    font-size: xx-small;
  }*/



}
@media (max-width: 500px)
{

  .ModalContent{
    margin-top: -6vh;
    margin-left: 0;
    width: 100%;
  }

  .SharingModalContent{
    width: 100%;
    margin-left: 0;
    margin-top: 75vh;
    height: 20%;
    z-index: 1;

  }

  .QuestionClass{
    font-size: small;
  }

  #share-heading{
    text-align: center;

  }

  .sharing-options{
    display: flex;
    justify-content: center;
    gap: 2%;
  }

  .OptionButton{
    width: 13%;
  }

  .OptionButton p{
    visibility: collapse;
  }


}
.close-icon{
    height: 1.5vh;
    width: 1.5vh;
    cursor: pointer;
}

.close-icon:hover{
  filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);

}

.icon-container{
  display: flex;
  justify-content: right;
  margin-top: 2%;
  margin-right: 2.5%;
  
}

.icon-container-share{
  display: flex;
  justify-content: right;
  margin-top: 2.5%;
  margin-right: 3%;
  
}

.websiteLink{
  font-size: small;
}

.websiteLinkDiv{
  margin-top: 1vh;
}

.login-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f8f8;
  height: 100vh;
}

.login-message img {
  height: 25vh;
  margin-top: 2%;
}

.message-container {
  background-color: white;
  padding: 2vh;
  box-shadow: 0 0 1vh rgba(0, 0, 0, 0.1);
  border-radius: 1vh;
  width: 30vh; /* Adjust width as necessary */
  display: flex;
  flex-direction: column; /* Ensures form elements stack vertically */
  align-items: center; /* Aligns form elements to the center horizontally */
  padding:4vh;
  margin-top: 2%;
}

.message-container h1{
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
}

.message-container button {
  display: block; /* Allows margin auto to work for horizontal centering */
  width: 35%; /* Small width for the button */
  background: linear-gradient(to right, #005d97, #9ddeec 95%); /* Blue background color */
  color: white; /* Text color */
  text-align: center; /* Center text inside the button */
  border: none; /* No borders */
  border-radius: 5px; /* Slight rounding of corners */
  cursor: pointer; /* Pointer cursor on hover */
  font-family: 'BebasNeue', sans-serif;
  font-size: x-large;
  border-top-left-radius: 3vh;
border-bottom-left-radius: 3vh;
  border-top-right-radius: 3vh;
border-bottom-right-radius: 3vh;
  transform: translateZ(0) scale(1);
  transition: transform .2s;
  margin-top: 7%;
}

.message-container button:hover{
  background: #27292b;
  transform: scale(1.05);
 

}

.AnswerContainer h1{
  text-align: left;

}

.closeDiv{
  width: 115%;
  display: flex;
  justify-content: right;
  margin-top: -3vh;
  
}

`, "",{"version":3,"sources":["webpack://./src/MainScreen.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,4CAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;;;;EAKE;;;;AAIF;IACI,kBAAkB;IAClB,yBAAyB;;AAE7B;;;AAGA;EACE,yBAAyB;EACzB,MAAM;EACN,OAAO;EACP,WAAW,SAAS,eAAe;EACnC,YAAY,QAAQ,gBAAgB;EACpC,aAAa;EACb,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW,SAAS,eAAe;EACnC,YAAY,QAAQ,gBAAgB;EACpC,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;;;AAGZ;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;IACI,oCAAoC;AACxC;;;;;AAKA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;;;;;AAKrB;;AAEA;;;;EAIE;;AAEF;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,oCAAoC;IACpC,sBAAsB;;AAE1B;AACA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,iCAAiC;IACjC,yBAAyB;;;AAG7B;;AAEA;EACE,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;EACpC,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;;;AAGlB;;AAEA;EACE,aAAa;EACb,mBAAmB;;AAErB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;;;AAGrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;IACI,6HAA6H;IAC7H,sBAAsB;AAC1B;;AAEA;IACI,6HAA6H;IAC7H,sBAAsB;AAC1B;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,6BAA6B;;;AAGjC;;;AAGA;IACI,aAAa;IACb,iCAAiC;IACjC,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;;AAEd;;;AAGA;IACI,kBAAkB;IAClB,2BAA2B;CAC9B,8BAA8B;IAC3B,4BAA4B;CAC/B,+BAA+B;IAC5B,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;IACjC,qCAAqC;;;;EAIvC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;IAC/B,gCAAgC;;EAElC;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;;;;;AAKF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;;;AAGd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa,GAAG,kBAAkB;IAClC,cAAc,GAAG,mBAAmB;IACpC,wBAAwB;IACxB,cAAc,GAAG,oBAAoB;IACrC,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB,GAAG,sBAAsB;;IAEzC,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;;EAElB;;EAEA;IACE,qBAAqB,EAAE,qBAAqB;IAC5C,cAAc,EAAE,sCAAsC;EACxD;;EAEA;IACE,qBAAqB,EAAE,8BAA8B;IACrD,cAAc,EAAE,sCAAsC;EACxD;;;EAGA;IACE,uBAAuB,GAAG,8BAA8B;IACxD,mBAAmB,OAAO,gCAAgC;IAC1D,kBAAkB,QAAQ,gBAAgB;EAC5C;;EAEA;IACE,eAAe,EAAE,mCAAmC;EACtD;;EAEA;GACC,gBAAgB;GAChB,gBAAgB;;EAEjB;;AAEF;IACI,gBAAgB;IAChB,gBAAgB;;;AAGpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;;;AAGtB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;;EAElB;;EAEA;IACE,qBAAqB,EAAE,2CAA2C;IAClE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;;;EAGlB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB,EAAE,gBAAgB;EAC7C;;EAEA;IACE,yBAAyB,EAAE,cAAc;EAC3C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,uCAAuC;IACvC,UAAU;IACV,wBAAwB;IACxB,gBAAgB;;EAElB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;;;;EAI3B;;EAEA;IACE,sBAAsB;;EAExB;;EAEA;IACE,6BAA6B;;EAE/B;;;EAGA;IACE,6HAA6H;IAC7H,sBAAsB;EACxB;;EAEA;IACE,6HAA6H;IAC7H,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,iCAAiC;IACjC,yBAAyB;;EAE3B;;EAEA;IACE,aAAa;IACb,iCAAiC;IACjC,yBAAyB;EAC3B;;AAEF;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,2BAA2B;CAC9B,8BAA8B;IAC3B,4BAA4B;CAC/B,+BAA+B;IAC5B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;;AAGA;IACI,WAAW;AACf;;;;AAIA;IACI,eAAe;GAChB,2BAA2B;GAC3B,4BAA4B;IAC3B,kBAAkB;IAClB,UAAU;GACX,iDAAiD;IAChD,cAAc;IACd,gBAAgB;IAChB,uBAAuB;;AAE3B;;;;AAIA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,oCAAoC;IACpC,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;;;AAGrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,iBAAiB;IACjB,UAAU;;;AAGd;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;;AAGrB;;;;;AAKA;IACI,eAAe;IACf,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,UAAU;;;AAGd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,qCAAqC;;AAEzC;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,6BAA6B;AACjC;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;;AAEd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;;AAIA;;IAEI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;;;;AAIpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;;AAEjB;;AAEA;IACI,aAAa;;IAEb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;CAC5B,8BAA8B;IAC3B,4BAA4B;CAC/B,+BAA+B;EAC9B,kBAAkB;;;AAGpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;CAC5B,8BAA8B;IAC3B,4BAA4B;CAC/B,+BAA+B;EAC9B,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;;AAEhB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;;EAEZ;AACF;AACA;;EAEE;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,UAAU;;EAEZ;;;AAGF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;;EAElB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;;;EAGZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;;;AAIF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;;;EAGZ;;CAED;;;;;;;;;;;;;;;;;;IAkBG;;;;AAIJ;AACA;;;EAGE;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,UAAU;;EAEZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;;EAEpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,OAAO;EACT;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;;AAGF;AACA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,6HAA6H;;AAE/H;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,WAAW,EAAE,8BAA8B;EAC3C,aAAa;EACb,sBAAsB,EAAE,2CAA2C;EACnE,mBAAmB,EAAE,oDAAoD;EACzE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,wDAAwD;EACxE,UAAU,EAAE,+BAA+B;EAC3C,2DAA2D,EAAE,0BAA0B;EACvF,YAAY,EAAE,eAAe;EAC7B,kBAAkB,EAAE,kCAAkC;EACtD,YAAY,EAAE,eAAe;EAC7B,kBAAkB,EAAE,+BAA+B;EACnD,eAAe,EAAE,4BAA4B;EAC7C,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;AAC7B,8BAA8B;EAC5B,4BAA4B;AAC9B,+BAA+B;EAC7B,iCAAiC;EACjC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;;;AAGxB;;AAEA;EACE,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;AAElB","sourcesContent":["@font-face {\n    font-family: 'BebasNeue';\n    src: url('./BebasNeue.woff');\n    font-weight: normal;\n    font-style: normal;\n}\n\n/*@font-face {\n    font-family: 'Montserrat';\n    src: url('./Montserrat-VariableFont_wght.woff');\n    font-weight: normal;\n    font-style: normal;\n}*/\n\n\n\n.App{\n    text-align: center;\n    background-color: #f8f8f8;\n\n}\n\n\n.LoginModalOverlay{\n  background-color: #9bb9d5;\n  top: 0;\n  left: 0;\n  width: 100%;        /* Full width */\n  height: 100%;       /* Full height */\n  z-index: 1000;\n  position: fixed;\n  opacity: 0.5;\n  transition: opacity 0.3s ease;\n}\n\n.LoginModal{\n  top: 0;\n  left: 0;\n  width: 100%;        /* Full width */\n  height: 100%;       /* Full height */\n  z-index: 1000;\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n}\n\n.loginFormDiv{\n  background-color: #f8f8f8;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n  \n\n}\n\nh1{\n    font-family: 'BebasNeue', sans-serif;\n\n}\n\nh2{\n    font-family: 'BebasNeue', sans-serif;\n}\n\n\n\n\n.MenuButtons{\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 5%;\n    justify-content: space-between;\n    position: fixed;\n    background-color: #27292b;\n    z-index: 1;\n    \n}\n\n.MenuButtonsSection{\n    display: flex;\n    flex-direction: row;   \n    padding-bottom: 1vh;\n}\n\n\n\n.button-content{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.8vh\n}\n\n.UserButton{\n   \n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-size: x-large;\n    margin-left:1vh;\n    width: auto;\n    background-color: transparent;\n    font-family: 'BebasNeue', sans-serif;\n    font-weight: bold;\n    margin-bottom: 1vh;\n    border-radius: 0%;\n    \n    \n   \n\n}\n\n/*.UserButton:hover{\n  \n    background-color: #9bb9d5;\n\n}*/\n\n.username:hover{\n    background: white; \n    -webkit-background-clip: text; \n    -webkit-text-fill-color: transparent; \n    transform: scale(1.05);\n    \n}\n.username{\n    background: linear-gradient(to right, #23a1ee 5%, #9ddeec 95%); \n    -webkit-background-clip: text; \n    -webkit-text-fill-color: transparent; \n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n  \n\n}\n\n.guest{\n  background: linear-gradient(to right, #23a1ee 5%, #9ddeec 95%); \n  -webkit-background-clip: text; \n  -webkit-text-fill-color: transparent; \n  transform: translateZ(0) scale(1);\n  transition: transform .2s;\n  font-family: 'BebasNeue', sans-serif;\n  font-size: x-large;\n  font-weight: bold;\n  margin-left: 2vh;\n\n\n}\n\n.guestDiv{\n  display: flex;\n  align-items: center;\n\n}\n\n\n.BlueButton{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: auto;\n  background-color: transparent;\n  font-family: 'BebasNeue', sans-serif;\n  font-weight: bold;\n  font-size: xx-large;\n  \n\n}\n\n.LogoutButton p{\n  font-family: 'BebasNeue', sans-serif;\n  font-size: x-large;\n  transform: translateZ(0) scale(1);\n  transition: transform .2s;\n}\n\n.LogoutButton:hover p{\n  color: #9bb9d5;\n  transform: scale(1.05);\n}\n\n.Share-logo:hover{\n    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);\n    transform: scale(1.05);\n}\n\n.Logout-logo:hover{\n    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);\n    transform: scale(1.05);\n}\n\n\n\n.LogoutButton{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: auto;\n    margin-right: 1vh;\n    background-color: transparent;\n   \n\n}\n\n\n.Share-logo{\n    height: 3.7vh;\n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n  \n}\n\n.Logout-logo{\n    height: 3.7vh;\n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n}\n\n.LogoContainer{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;  \n}\n\n.App-logo{\n    height: 25vh;\n    border-radius: 50%;\n    box-shadow: 0 0.5vh 1vh rgba(0, 0, 0, 0.1);\n    margin-top: 7vh;\n\n}\n\n.tabbed{\n    display: flex;\n    margin-top: 2vh;\n    flex-direction: row;\n    justify-content: center;\n}\n.InputQuestion{\n    display: flex;\n    flex-direction: column;\n}\n\n.QuestionClassForm{\n    display: flex;\n    flex-direction: row;\n    gap: 1vh;\n    width: 60%;\n    \n}\n\n\n.QuestionClass{\n    font-size: x-large;\n    border-top-left-radius: 3vh;\n\tborder-bottom-left-radius: 3vh;\n    border-top-right-radius: 3vh;\n\tborder-bottom-right-radius: 3vh;\n    text-align: left;\n    outline: 0.3vh solid #27292b;\n    transition: outline 0.1s ease-out;\n    font-family: 'Montserrat', sans-serif;\n    \n  \n    \n  }\n\n  .QuestionClass:hover{\n    outline: 0.3vh solid #9bb9d5;\n    border: 0.3vh solid transparent;\n    transition: outline 0.1s ease-in;\n   \n  }\n\n  .QuestionClass:focus{\n    outline:  0.3vh solid #6fa4bf;\n    border: 0.3vh solid transparent;\n  }\n\n\n  \n\n.QuestionSection{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 1vh;\n}\n\n.AnswerContainer{\n    display: flex;\n    flex-direction: column;\n    width: 60%;\n    \n    \n}\n\n.Answer{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n\n}\n\n  \n.document-section {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2vh;\n    margin-left: 1%;\n    margin-top: 4vh;\n    width: 120%;\n  }\n  \n  .document-square {\n    width: 17.5vh;  /* Reduced width */\n    height: 17.5vh;  /* Reduced height */\n    border: 0.3vh solid #ccc;\n    padding: 0.5vh;  /* Reduced padding */\n    overflow: hidden;\n    background-color: #f9f9f9;\n    box-shadow: 1vh 0.8vh 1vh rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .document-title {\n    font-size: large;  /* Reduced font size */\n  \n    text-align: left;\n    font-family: 'Montserrat', sans-serif;\n    margin-top: 0vh;\n    font-weight: 500;\n    \n  }\n  \n  .no-underline-link {\n    text-decoration: none; /* Remove underline */\n    color: inherit; /* Inherit the color from the parent */\n  }\n  \n  .no-underline-link:hover {\n    text-decoration: none; /* Remove underline on hover */\n    color: inherit; /* Inherit the color from the parent */\n  }\n  \n  \n  .document-square.center {\n    justify-content: center;  /* Center content vertically */\n    align-items: center;      /* Center content horizontally */\n    text-align: center;       /* Center text */\n  }\n  \n  .document-section:hover {\n    cursor: pointer; /* Change cursor to hand on hover */\n  }\n  \n  .sources-section h2{\n   text-align: left;\n   margin-left: 1vh;\n    \n  }\n\n.StatusMessage{\n    text-align: left;\n    margin-left: 1vh;\n\n\n}\n\n.output-section{\n    text-align: justify;\n    background-color: #f1f1f1;\n    padding: 3.5vh;\n    margin-bottom: 2vh;\n    \n    \n}\n.output-verification {\n    background-color: #fafafa;\n    border-radius: 4px;\n    padding: 10px;\n    margin: 20px;\n    max-width: 770px;\n  \n  }\n  \n  .output-tokens {\n    white-space: pre-line; /* Ensures that line breaks are respected */\n    color: #333;\n    font-size: larger;\n    line-height: 3.5vh;\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 400;\n \n   \n  }\n\n  .spinner {\n    display: inline-block;\n    vertical-align: auto;\n    margin-left: 1vh; \n    width: 1.25vh;\n    height: 1.25vh;\n    border: 0.5vh solid #9bb9d5;\n    border-radius: 50%;\n    border-top: 0.5vh solid #27292b;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n  .green-ball, .red-ball, .gray-ball,.orange-ball {\n    height: 20px;\n    width: 20px;\n    border-radius: 50%;\n    vertical-align: middle;\n    display: inline-block;\n    margin-right: 5px;\n  }\n  \n  .green-ball {\n    background-color: #00ff00; /* Green color */\n  }\n  \n  .red-ball {\n    background-color: #ff0000; /* Red color */\n  }\n  \n  .gray-ball{\n    background-color: gray;\n  }\n  \n  .orange-ball{\n    background-color:orange;\n  }\n  \n  .tooltip {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .tooltip .tooltiptext {\n    visibility: hidden;\n    width: 35%;\n    background-color: #f8f8f8;\n    color: #000;\n    text-align: justify;\n    border-radius: 1vh;\n    padding: 1.5vh;\n    position: absolute;\n    z-index: 1;\n    bottom: 100%;\n    left: 50%;\n    box-shadow: 0vh 1vh 3vh rgba(0,0,0,0.1);\n    opacity: 0;\n    transition: opacity 0.3s;\n    font-size: small;\n    \n  }\n  \n  .tooltip:hover .tooltiptext {\n    visibility: visible;\n    opacity: 1;\n  }\n\n\n  #settings-btn{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    background-color: transparent;\n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n    \n    \n    \n  }\n\n  #settings-btn:hover{\n    transform: scale(1.05);\n\n  }\n\n  .AskButton{\n    background-color: transparent;\n   \n  }\n\n \n  .AskLogo:hover{  \n    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);\n    transform: scale(1.05);\n  }\n\n  .SettingsLogo:hover{  \n    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);\n    transform: scale(1.05);\n  }\n\n  .SettingsLogo{\n    height: 4.5vh;\n    position: relative;\n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n    \n  }\n\n  .AskLogo{\n    height: 4.5vh;\n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n  }\n\n#inputMessage{\n    font-family: 'Montserrat', sans-serif;\n    font-size: large;\n}\n\nbody{\n    background-color: #f8f8f8;\n}\n\n.OptionButton{\n    background-color: #27292b;\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 700;\n    font-size: x-small;\n    width: 98%;\n    height: 3.5vh;\n    border-top-left-radius: 3vh;\n\tborder-bottom-left-radius: 3vh;\n    border-top-right-radius: 3vh;\n\tborder-bottom-right-radius: 3vh;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n}\n\n.OptionButton:hover{\n    background-color: #9bb9d5;\n    transform: scale(1.05);\n}\n\n\n.Option-logo{\n    height: 2vh;\n}\n\n\n\n.SharingModalContent{\n    position: fixed;\n   /* border: 1px solid #ccc;*/\n   border: 0.25vh solid #9bb9d5;\n    border-radius: 2vh;\n    width: 15%;\n   /* box-shadow: 0 0.5vh 1.5vh rgba(0, 0, 0, 0.1);*/\n    margin-top: 3%;\n    margin-left: 80%;\n    background-color: white;\n \n}\n\n\n\n.copiedMessage{\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 0;\n    font-size: small;\n\n}\n\n.checkmark{\n    height: 2.5vh;\n}\n.copiedMessage h1{\n    font-family: 'BebasNeue', sans-serif;\n    font-size: x-large;\n    \n}\n\n.sharingContainer{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-bottom: 4%;\n    \n\n}\n\n.sharing-options{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 0.2vh;\n    row-gap: 0;\n    \n   \n}\n\n#share-heading{\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 500;\n    font-size: small;\n    margin-left: 3%;\n    margin-bottom: 0%;\n\n\n}\n\n\n\n\n.ModalContent{\n    position: fixed;\n    background-color: white;\n    border: 0.25vh solid #9bb9d5;\n    border-radius: 2vh;\n    width: 17%;\n    margin-left: 1%;\n    margin-top: -15%;\n    z-index: 1;\n   \n\n}\n\n.ModalContent h2 {\n  font-size: larger;\n}\n\n.ModalContent label, option{\n    font-family: 'Montserrat', sans-serif;\n   \n}\n\n\n\n.SearchConfiguration{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n       \n}\n\n.SearchConfiguration label{\n    font-size: small;\n    font-weight: 400;\n}\n\n.search-section{\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-around;\n}\n\n\n\n.WeightsConfiguration{\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n    margin-top: 5%;\n    margin-left: 10%;\n}\n.weight-labels{\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n    \n}\n\n.weight-labels label{\n    font-size: small;\n    text-align: left;\n}\n\n\n\n.weight-buttons{\n\n    display: flex;\n    flex-direction: row;\n    width: 110%;\n    justify-content: space-between;\n    margin-top: -2.5vh;\n    margin-left: -3%;\n    \n     \n\n}\n\n.slider{\n  accent-color: #9bb9d5;\n  cursor: pointer;\n  \n}\n\n.weight-btn-container{\n    display: flex;\n \n    flex-direction: row;\n    align-items: center;\n}\n\n.weightSliderContainer{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-top: -0.5vh;\n}\n.weight-buttons button{\n    font-size: smaller;\n    text-align: center;\n    background-color: transparent;\n    color:#27292b;\n    font-family: 'Montserrat', sans-serif;\n    font-weight: bold;\n}\n\n.DocumentNumConfiguration{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.DocumentNumConfiguration label{\n  font-size: small;\n}\n\n.combobox{\n  width: 25%;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 700;\n  background-color: #9bb9d5;\n  border-top-left-radius: 3vh;\n\tborder-bottom-left-radius: 3vh;\n    border-top-right-radius: 3vh;\n\tborder-bottom-right-radius: 3vh;\n  font-size: x-small;\n  \n  \n}\n\n.combobox:hover{\n  background-color: #27292b;\n  color: white;\n}\n\n.combobox:focus{\n  background-color: #27292b;\n  color: white;\n}\n\n.date-picker-group{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 37%;\n}\n\n.date-picker-group label{\n  font-family: 'Montserrat', sans-serif;\n  font-size: small;\n}\n\n.date-picker-group input{\n  height: 10%;\n  margin-top: 1vh;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 700;\n  font-size: x-small;\n  background-color: #9bb9d5;\n  border-top-left-radius: 3vh;\n\tborder-bottom-left-radius: 3vh;\n    border-top-right-radius: 3vh;\n\tborder-bottom-right-radius: 3vh;\n  width: 65%;\n}\n\n.date-picker-group:hover input{\n  \n  background-color: #27292b;\n  color: white;\n}\n\n.date-picker-group:focus{\n  \n  background-color: #27292b;\n  color: white;\n}\n.DateConfiguration{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  gap: 10%;\n  margin-top: 2vh;\n}\n\n.temperature-desc{\n  width: 110%;\n  font-size: smaller;\n  display: flex;\n  text-align: center;\n}\n\n#tempSlider{\n  margin-top: 0%;\n\n}\n\n#StreamConfiguration{\n  margin-bottom: 3%;\n}\n\n@media (max-width: 1520px){\n  .ModalContent{\n    width: 30%;\n    \n  }\n}\n@media (max-width: 1000px){\n\n  .ModalContent{\n    margin-top: 7vh;\n    width: 50%;\n  }\n\n  .SharingModalContent{\n    width: 40%;\n    margin-top: 7vh;\n    margin-left: 58%;\n    z-index: 1;   \n\n  }\n  \n\n}\n\n@media (max-width: 1000px){\n  .ModalContent{\n    margin-top: -20vh;\n    margin-left: 1vh;\n    \n  }\n}\n\n@media (max-height: 500px){\n  .ModalContent{\n    margin-top: -43vh;\n    margin-left: 1vh;\n    width: 35%;\n  \n    \n  }\n\n  .ModalContent h2{\n    font-size: small;\n  }\n\n  .combobox{\n    font-size: xx-small;\n  }\n\n  .search-section label{\n    font-size: xx-small;\n  }\n\n  .weight-labels label{\n    font-size: xx-small;\n  }\n\n  .DocumentNumConfiguration label{\n    font-size: xx-small;\n  }\n\n  .SharingModalContent{\n    width: 25%;\n    margin-left: 120vh;\n  }\n\n\n\n}\n\n@media (min-height: 501px) and (max-height: 1000px){\n  .ModalContent{\n    margin-top: -30vh;\n    margin-left: 1vh;\n    width: 40%;\n  \n    \n  }\n\n /* .ModalContent h2{\n    font-size: small;\n  }\n\n  .combobox{\n    font-size: xx-small;\n  }\n\n  .search-section label{\n    font-size: xx-small;\n  }\n\n  .weight-labels label{\n    font-size: xx-small;\n  }\n\n  .DocumentNumConfiguration label{\n    font-size: xx-small;\n  }*/\n\n\n\n}\n@media (max-width: 500px)\n{\n\n  .ModalContent{\n    margin-top: -6vh;\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .SharingModalContent{\n    width: 100%;\n    margin-left: 0;\n    margin-top: 75vh;\n    height: 20%;\n    z-index: 1;\n\n  }\n\n  .QuestionClass{\n    font-size: small;\n  }\n\n  #share-heading{\n    text-align: center;\n\n  }\n\n  .sharing-options{\n    display: flex;\n    justify-content: center;\n    gap: 2%;\n  }\n\n  .OptionButton{\n    width: 13%;\n  }\n\n  .OptionButton p{\n    visibility: collapse;\n  }\n\n\n}\n.close-icon{\n    height: 1.5vh;\n    width: 1.5vh;\n    cursor: pointer;\n}\n\n.close-icon:hover{\n  filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);\n\n}\n\n.icon-container{\n  display: flex;\n  justify-content: right;\n  margin-top: 2%;\n  margin-right: 2.5%;\n  \n}\n\n.icon-container-share{\n  display: flex;\n  justify-content: right;\n  margin-top: 2.5%;\n  margin-right: 3%;\n  \n}\n\n.websiteLink{\n  font-size: small;\n}\n\n.websiteLinkDiv{\n  margin-top: 1vh;\n}\n\n.login-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #f8f8f8;\n  height: 100vh;\n}\n\n.login-message img {\n  height: 25vh;\n  margin-top: 2%;\n}\n\n.message-container {\n  background-color: white;\n  padding: 2vh;\n  box-shadow: 0 0 1vh rgba(0, 0, 0, 0.1);\n  border-radius: 1vh;\n  width: 30vh; /* Adjust width as necessary */\n  display: flex;\n  flex-direction: column; /* Ensures form elements stack vertically */\n  align-items: center; /* Aligns form elements to the center horizontally */\n  padding:4vh;\n  margin-top: 2%;\n}\n\n.message-container h1{\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 400;\n}\n\n.message-container button {\n  display: block; /* Allows margin auto to work for horizontal centering */\n  width: 35%; /* Small width for the button */\n  background: linear-gradient(to right, #005d97, #9ddeec 95%); /* Blue background color */\n  color: white; /* Text color */\n  text-align: center; /* Center text inside the button */\n  border: none; /* No borders */\n  border-radius: 5px; /* Slight rounding of corners */\n  cursor: pointer; /* Pointer cursor on hover */\n  font-family: 'BebasNeue', sans-serif;\n  font-size: x-large;\n  border-top-left-radius: 3vh;\nborder-bottom-left-radius: 3vh;\n  border-top-right-radius: 3vh;\nborder-bottom-right-radius: 3vh;\n  transform: translateZ(0) scale(1);\n  transition: transform .2s;\n  margin-top: 7%;\n}\n\n.message-container button:hover{\n  background: #27292b;\n  transform: scale(1.05);\n \n\n}\n\n.AnswerContainer h1{\n  text-align: left;\n\n}\n\n.closeDiv{\n  width: 115%;\n  display: flex;\n  justify-content: right;\n  margin-top: -3vh;\n  \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
